<template>
  <layout-guest>
    <main class="container-wrap-base">
      <div class="rectangle-base">
        <div class="row">
          <div class="col-sm-12">
            <div class="row">
              <v-col cols="12" sm="5" md="5">
                <img
                  :src="
                    isError
                      ? basePath + 'assets/images/login/error.svg'
                      : basePath + 'assets/images/login/succes@2x.png'
                  "
                  class="header-brand-img-login2 centrado-img"
                  alt="logo"
                />
              </v-col>

              <v-col cols="12" sm="7" md="7">
                <v-col cols="12" sm="12" md="12">
                  <p class="source-sans-pro-ligh">
                    {{ title }}
                  </p>

                  <small class="source-sans-pro-ligh2">
                    {{ message }}
                  </small>
                </v-col>

                <div class="row">
                  <v-col cols="12" sm="12" md="12" class="mb">
                    <v-flex xs12 offset-xs8>
                      <v-btn
                        depressed
                        dark
                        :color="entityConfig.primaryColor"
                        :style="`color: ${entityConfig.secondaryColor}`"
                        @click="$router.push(urlLogin)"
                      >
                        {{ $t("login.incio") }}
                      </v-btn>
                    </v-flex>
                  </v-col>
                </div>
              </v-col>
            </div>
          </div>
        </div>
      </div>
      <overlay :visible="spinner" :opacity="1"></overlay>
    </main>
  </layout-guest>
</template>

<style scoped lang="scss">
@import "./supplier.style";
</style>

<script>
import LayoutGuest from "../../components/layouts/layout-guest.vue";
import Api from "../../Services/index";
import Overlay from "../../components/layouts/overlay.vue";

export default {
  name: "App",
  data() {
    return {
      basePath: process.env.VUE_APP_CONTEXT_PATH,
      title: "Oh no, algo ha ido mal",
      isError: false,
      entityConfig: {},
      message:"",
      spinner: true,
      urlLogin: "/",
    };
  },
  components: {
    Overlay,
    "layout-guest": LayoutGuest,
  },
  mounted() {
    setTimeout(() => {
      this.entityConfig = this.$store.state.entityConfig.config;
    }, 1000);
    let userId = this.$route.query.id;
    let token = this.$route.query.token;

    if (userId && token) {
      this.sendConfirmation(userId, token);
    } else {
      this.isError = true;
      this.spinner = false;
      return;
    }
  },
  methods: {
    sendConfirmation(userId, token) {
      this.spinner = true;
      delete Api.defaults.headers.common["Authorization"];
      delete Api.defaults.headers["Authorization"];
      Api.patch(`/usuarios/${userId}/confirmar-email?token=${token}`)
        .then(() => {
          this.isError = false;
          this.title = "¡Todo Listo!";
          this.message =
            "Tu usuario ya esta activado, ya puedes iniciar sesión";
        })
        .catch((error) => {
          if(error.response.data.code == 739){
            this.message = this.$t("login.tokenExpiradoConfirmar")
          }else{
            this.message =  this.$t("login.losientoError")
          }
          this.$showError(this, error.response.data);
          this.isError = true;
        })
        .finally(() => {
          this.spinner = false;
        });
    },
  },
};
</script>
